import { FirebaseJoinService } from './firebase/firebase-join-service';

export class JoinServiceBase extends FirebaseJoinService {}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/base/join-service-base.ts